<div class="modal-header sg-background__secondary sg-rounded-top border-bottom-0 d-flex p-0">
    <div class="w-100 sg-color__primary d-flex -content-align h-100">
        <div class="d-flex align-self-center">
            <ng-content select="[header]"></ng-content>
        </div>
    </div>
    <div class="triangle unset-width"></div>
    <div class="modal-close sg-color__white sg-background__primary d-flex justify-content-center h-100 sg-rounded-top-right" (click)="modService.dismiss()">
        <div class="d-flex align-self-center">
            <mlp-ng-icon name="close" size="small"></mlp-ng-icon>
        </div>
    </div>
</div>

<div class="modal-body sg-rounded-bottom" ngbAutofocus>
    <ng-content select="[body]"></ng-content>
</div>

